var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"d-flex align-items-center w-100 text-nowrap",class:_vm.del ? 'justify-content-between' : 'justify-content-end'},[(_vm.del)?_c('b-btn',{staticClass:"text-14 text-white py-2",style:({
      width: '65px',
    }),on:{"click":function($event){return _vm.deleteEvent()}}},[_vm._v(" 삭제")]):_vm._e(),_c('div',_vm._l((_vm.btns),function(item,i){return _c('b-btn',{key:i,staticClass:"py-2 ml-3 text-14",style:({
        width: '95px',
      }),attrs:{"variant":item.variant,"disabled":item.disable},on:{"click":function($event){return _vm.btnEvent(item.value)}}},[_vm._v(" "+_vm._s(item.text)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }